import { SimpleFlowchartStruct } from "../../structs/risk-classification/simple-flowchart.struct";

export class SimpleFlowchartRequest {
    public flowchart: SimpleFlowchartStruct;
}